import React from "react";
import { View, StyleSheet } from "react-native";
import { TermsForm } from "../shared/TermsForm";
import { useEntityEdit } from "@/contexts/EntityEditContext";
import { ClientType } from "@/types/db/clients";

export interface ClientTermsTabProps {
  client: ClientType | null;
  loading?: boolean;
}

export function ClientTermsTab({ client, loading = false }: ClientTermsTabProps) {
  // Get edit context
  const { editing, formData, updateFormData } = useEntityEdit<ClientType>();

  // Get current terms (from formData in edit mode, or client in preview mode)
  const currentTerms = editing ? formData?.meta_data?.terms || {} : client?.meta_data?.terms || {};

  const handleUpdateTerms = (newTerms: Record<string, any>) => {
    updateFormData({
      ...formData,
      meta_data: {
        ...formData.meta_data,
        terms: newTerms,
      },
    });
  };

  return (
    <View style={styles.content}>
      <TermsForm terms={currentTerms} onUpdateTerms={handleUpdateTerms} editing={editing} loading={loading} />
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
});
